import React from 'react';
import {BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import Navbar from './Navbar/Navbar'
import Footnote from './Footnote/Footnote'
import Slider from './Slider/Slider'
import Traceability from './Traceability/Traceability'
import Irrigation from './Irrigation/Irrigation'
import Honey from './Honey/Honey'
import Automation from './Automation/Automation'
import Rice from './Rice/Rice'
import Agronomist from './Agronomist/Agronomist'
import Farmcompany from './Farmcompany/Farmcompany'
import Aboutus from './Aboutus/Aboutus'
import Contactus from './Contactus/Contactus'
import Farmer from './Farmer/Farmer'
import Leadform from './Farmer/Leadform'
import Newcrop from './Farmer/Newcrop'
import SearchPage from './Farmer/search';
import Login from './Farmer/Login';
function App() 
{
return (
  <Router>
  <>
<Routes>
          <Route path="/automation" element={
          <>
          <Navbar/>
          <Automation/>
          <Footnote/>
          </>
          }/>
          <Route path="/agronomist" element={
          <>
          <Navbar/>
          <Agronomist />
          <Footnote/>
          </>
          }/>
          <Route path="/farmcompany" element={
          <>
          <Navbar/>
          <Farmcompany />
          <Footnote/>
          </>
          }/>
          <Route path="/irrigation" element={
          <>
          <Navbar/>
          <Irrigation />
          <Footnote/>
          </>
          }/>
          <Route path="/rice" element={
          <>
          <Navbar/>
          <Rice />
          <Footnote/>
          </>
          }/>
          <Route path="/honey" element={
          <>
          <Navbar/>
          <Honey />
          <Footnote/>
          </>
          }/>
          <Route path="/traceability" element={
          <>
          <Navbar/>
          <Traceability />
          <Footnote/>
          </>
          }/>
          <Route path="/aboutus" element={
          <>
          <Navbar/>
          <Aboutus/>
          <Footnote/>
          </>
          }/>
          <Route path="/contactus" element={
          <>
          <Navbar/>
          <Contactus/>
          <Footnote/>
          </>
          }/>
          <Route path="/farmer" element={
          <>
          <Navbar/>
          <Farmer/>
          <Footnote/>
          </>
          }/>

          <Route path="/newcrop" element={
          <>
          <Navbar/>
          <Newcrop/>
          <Footnote/>
          </>
          }/>

          <Route path="/leadform" element={
          <>
          <Navbar/>
          <Leadform/>
          <Footnote/>
          </>
          }/>
          
          <Route path="/search" element={
          <>
          <Navbar/>
          <SearchPage/>
          <Footnote/>
          </>
          }/>

          <Route path="/login" element={
          <>
          <Navbar/>
          <Login/>
          <Footnote/>
          </>
          }/>


          <Route path="/" element={
          <>
          <Navbar/>
          <Slider/>
          <Footnote/>
          </>
        } 
          />

</Routes>

  </>
  </Router>
)
}
export default App;